import React from "react";
import WorkspaceIconSvg from "./24/workspace_project.svg";

export default function WorkspaceSvg() {
  return (
    <div
      className="
        flex aspect-square w-6 items-center justify-center rounded-full 
        bg-green-100 p-0.5 text-black"
    >
      <WorkspaceIconSvg />
    </div>
  );
}
